<template lang="pug">
//- NOTICE: deprecated
//iframe(height="0", width="0", style="display:none", :src="this.$user.loginUrl")
</template>

<script>

import tabs from '@/core/site-map/map.json'

// NOTICE: deprecated
const resolveUser = (data) => {
  /** Set payload as form-data */
  var formData = new FormData()
  formData.append('user', data.username)
  formData.append('pass', data.password)

  return new Promise((resolve, reject) => {
    this.api.post(this.api.$.login, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then((response) => {
      response.data.login = this.api.$.Login + response.data.sk
      response.data.email = response.data.username

      resolve(response.data)
    }).catch(() => reject)
  })
}

const getModules = () => {
  const authUser = JSON.parse(window.localStorage.getItem('evedUser'))
  var modules = []

  if (authUser && authUser.token && authUser.modules) {
    modules = authUser.modules
  }

  return modules
}

const getPermissions = () => {
  const authUser = JSON.parse(window.localStorage.getItem('evedUser'))
  var permissions = []

  if (authUser && authUser.token && authUser.permissions) {
    permissions = authUser.permissions
  }

  return permissions
}

export default {
  name: 'legacy-auth',

  created() {
    const authUser = JSON.parse(window.localStorage.getItem('evedUser'))

    if (authUser && authUser.token) {
      this.$user.email = authUser.username
    }
  },

  resolveUser: resolveUser,

  allowedModules: () => {
    var modules = {}
    var menus = getModules()

    Object.keys(tabs).forEach((v, k) => {
      // if (v === '_modules') return
      if (!tabs[v].allow || check(v)) {
        modules[v] = {}
        modules[v].subtabs = menus[tabs[v].alias || tabs[v]]
        modules[v].label = tabs[v].alias || tabs[v]

        //
        if (tabs[v].subtabs) {
          modules[v].subtabs = Object.assign({}, modules[v].subtabs, tabs[v].subtabs)
        }
      }
    })

    function check(tab) {
      const permissions = getPermissions()
      var passed = true

      Object.keys(tabs[tab].allow).forEach((v, k) => {
        if (~permissions.indexOf('deny' + v) && tabs[tab].allow[v] === 'all') {
          passed = false
        }
        if (~permissions.indexOf('deny' + v) && tabs[tab].allow[v] === 'any') {
          passed = true
        }
      })

      return passed
    }

    return modules
  }
}

</script>



// WEBPACK FOOTER //
// index.vue?df6b2718